// КРОШКИ ПУБЛИЧНОЙ СПРАВКИ — ОДИН КОМПОНЕНТ НА СТАТЬЮ И РАЗДЕЛ (ТЗ ~/projects/HELP-WARM-FIX-TZ.md §6а п.5–6, владелец
// 26.10.2026): «Справка › Раздел» над заголовком статьи и «Справка › Раздел» на странице раздела (последний шаг — текущая
// страница, не ссылка). На любой ширине, в той же колонке, что шапка сайта. Ссылки — next/link (Next сам подгружает
// видимые ссылки заранее, ТЗ §2 п.6). В голом островке приложения (`?bare=1`) крошек нет (help.css).
import Link from 'next/link';

export function HelpCrumbs({
  locale,
  helpTitle,
  section,
  current = false,
}: {
  locale: string;
  /** «Справка». */
  helpTitle: string;
  /** Раздел: слаг и название; нет — только «Справка». */
  section?: { slug: string; title: string } | undefined;
  /** Раздел — текущая страница (страница раздела): без ссылки. */
  current?: boolean;
}) {
  return (
    <nav className="help-crumbs" aria-label={helpTitle}>
      <Link href={`/${locale}/help`}>{helpTitle}</Link>
      {section?.title ? (
        <>
          <span aria-hidden> › </span>
          {current ? (
            <span className="help-crumbs-cur" aria-current="page">
              {section.title}
            </span>
          ) : (
            <Link href={`/${locale}/help/${section.slug}`}>{section.title}</Link>
          )}
        </>
      ) : null}
    </nav>
  );
}
